import { ChangeDetectionStrategy, Component, input, model, output, signal } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { UserResetPasswordDto } from '@workspace/data-types';
import { LuxonDatePipe } from '../../../../pipes';
import { AuraEditWrapperComponent } from '../../edit-wrapper/form-edit-wrapper.component';
import { AuraPasswordConfirmFormComponent } from '../form/password-confirm-form.component';

@Component({
  selector: 'aura-password-confirm-edit',
  templateUrl: './password-confirm-edit.component.html',
  imports: [MatDividerModule, AuraPasswordConfirmFormComponent, AuraEditWrapperComponent, LuxonDatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuraPasswordConfirmEditComponent {
  isEditing = model<boolean>(false);
  isAllowedToEdit = input<boolean>(false);

  lastUpdateAt = input<Date>();
  passwordSaved = output<UserResetPasswordDto>();

  currentPassword = signal<UserResetPasswordDto | null>(null);
  shouldClear = signal(false);

  savePassword(password: UserResetPasswordDto): void {
    this.passwordSaved.emit(password);
    this.clearForm();
  }

  clearForm() {
    this.shouldClear.set(true);
    setTimeout(() => this.shouldClear.set(false), 0);
  }
}
